import classNames from 'classnames';
import { Tooltip } from '@/shared/components/molecules/Tooltip';

// https://docs.chainflip.io/validators/validator-types-and-states
export const ValidatorOnlineStatusIndicator = ({
  isOnline,
  className,
  offlineClassName = 'bg-cf-red-1',
}: {
  isOnline: boolean;
  className?: string;
  offlineClassName?: string;
}) => (
  <div className={classNames('flex items-center', className)}>
    <Tooltip
      content={
        isOnline
          ? 'Validator is online.'
          : 'Validator has not submitted a heartbeat within the last interval.'
      }
    >
      <div
        className={classNames(
          'h-2 w-2 rounded-full',
          isOnline ? 'bg-cf-green-1' : offlineClassName,
        )}
      />
    </Tooltip>
  </div>
);
